import { MyInfoType } from "DataTypes/Redux";

const baseUrl = process.env.REACT_APP_BASE_URL || '';

export const FormateMyInfoData: (data: any) => MyInfoType = (data) => {
  return {
    id: data?.id,
    firstname: data?.firstName,
    lastname: data?.lastName,
    corporateOrg: data?.corporateOrg,
    userName: data?.userName,
    email: data?.userName || "",
    userType: data?.userType,
    profileImageUrl: data?.profilePicture
      ? `${baseUrl}${data?.profilePicture}`
      : "",
    phone: data?.phone || "",
    beProfessionalVerified: data?.beProfessionalVerified || false,
  };
};
